/**
 * Turns the discards a save reported, or the editor detected on paste, into
 * the lines a notice shows. Each discard is {node, reason, detail}, the shape
 * the host's save response carries in `sanitization.discarded[]`.
 * @param {Array<{node: string, reason: string, detail: string|null}>} discards
 * @param {{tag: string, unsafe: string, embedDomain: string, embedUrl: string}} labels - Localized templates with a {detail} slot
 * @returns {string[]} Unique lines, in order of first appearance
 */
export function describeDiscards(discards, labels) {
    const templates = {
        tag_not_allowed: labels.tag,
        unsafe_attribute: labels.unsafe,
        unsafe_url: labels.unsafe,
        embed_domain_not_allowed: labels.embedDomain,
        embed_url_not_embeddable: labels.embedUrl,
    };

    const lines = (discards ?? []).map(discard => {
        const template = templates[discard.reason] ?? labels.tag;

        return template.replace('{detail}', discard.detail ?? discard.node ?? '');
    });

    return [...new Set(lines)];
}
